var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-date-picker',{attrs:{"label":"Select Date Range","range":""},on:{"change":_vm.setDateRange},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }